export const PARCEL_LAYER_MIN_ZOOM = 14

export const VECTOR_URL =
  "https://reportallusa.com/api/rest_services/client=" +
  import.meta.env.VITE_APP_REPORTALL_CLIENT_KEY +
  "/ParcelsVectorTile/MapBoxVectorTileServer/tile/{z}/{x}/{y}.mvt"
